import { createContext } from "react";

export const ObjectiveItemContext = createContext();
